module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_sns_01-7b677b2016c3d6a0d97a5f9084a0b8e1.jpg";